export interface LegacyUserToken {
    sub: string;
    role: string[];
    exp: number;
    iat: number;
}

export interface LegacyAuthStore {
    token?: string;
    user?: LegacyUserToken;
    role?: string;
    loggedIn: boolean;
}

const REGISTERED_EMAIL = 'registeredEmail';

const AUTH_STORE = 'authStore';

const SELECTED_ACCOUNTING_AREA = 'partnerManagerSelectedAccountingAreaId';

const USER_LANGUAGE = 'lang';

function withLocalStorage() {
    return {
        clear,
        setRegisteredEmail,
        getRegisteredEmail,
        setAuthStore,
        getAuthStore,
        setSelectedAccountingArea,
        getSelectedAccountingArea,
        setUserLanguage,
        getUserLanguage,
    };

    function clear() {
        console.log('clearing locally stored data');
        localStorage.clear();
    }

    function setRegisteredEmail(email: string | null) {
        setItem<string>(REGISTERED_EMAIL, email);
    }

    function getRegisteredEmail(): string | null {
        return getItem<string>(REGISTERED_EMAIL);
    }

    function setAuthStore(value: LegacyAuthStore) {
        setItem<LegacyAuthStore>(AUTH_STORE, value);
    }

    function getAuthStore(): LegacyAuthStore | null {
        return getItem<LegacyAuthStore>(AUTH_STORE);
    }

    function setSelectedAccountingArea(selectedId: string | null) {
        setItem<string>(SELECTED_ACCOUNTING_AREA, selectedId);
    }

    function getSelectedAccountingArea(): string | null {
        return getItem<string>(SELECTED_ACCOUNTING_AREA);
    }

    function setUserLanguage(value: string) {
        setItem<string>(USER_LANGUAGE, value);
    }

    function getUserLanguage(): string {
        return getItem<string>(USER_LANGUAGE);
    }

    function setItem<T>(key: string, value: T | null) {
        if (value === null) {
            localStorage.removeItem(key);
        } else {
            localStorage.setItem(key, JSON.stringify(value));
        }
    }

    function getItem<T>(key: string): T {
        const result = JSON.parse(localStorage.getItem(key));
        return result as T;
    }
}

export default withLocalStorage;
